import type { ColumnDef } from '@tanstack/react-table';
import styled from 'styled-components';

import { type GetSitesQuery, type GetDeliveryZoneQuery } from 'data/__generated__';
import { textColumn } from 'components/DataTable';

export type AllSiteRow = GetSitesQuery['sites'][number];
export type ZoneSiteRow = GetDeliveryZoneQuery['deliveryZone']['sites'][number];

export const allSitesColumns: ColumnDef<AllSiteRow, unknown>[] = [
    textColumn<AllSiteRow, Record<string, unknown>>({
        accessorKey: 'name',
        header: 'Site',
        defaultVisible: true,
    }),
    textColumn<AllSiteRow, Record<string, unknown>>({
        accessorKey: 'organizationName',
        header: 'Organisation',
        defaultVisible: true,
    }),
    textColumn<AllSiteRow, Record<string, unknown>>({
        id: 'currentZone',
        accessorFn: (row) => row.deliveryZone?.name ?? '',
        header: 'Zone actuelle',
        defaultVisible: true,
        cell: ({ row }) => {
            const zone = row.original.deliveryZone;
            if (!zone) return <span>—</span>;
            return (
                <ZoneCell>
                    <ZoneSwatch style={{ backgroundColor: zone.color }} />
                    {zone.name}
                </ZoneCell>
            );
        },
    }),
];

export const zoneSitesColumns: ColumnDef<ZoneSiteRow, unknown>[] = [
    textColumn<ZoneSiteRow, Record<string, unknown>>({
        accessorKey: 'name',
        header: 'Site',
        defaultVisible: true,
    }),
    textColumn<ZoneSiteRow, Record<string, unknown>>({
        accessorKey: 'organizationName',
        header: 'Organisation',
        defaultVisible: true,
    }),
];

const ZoneCell = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 6px;
`;

const ZoneSwatch = styled.span`
    width: 12px;
    height: 12px;
    border-radius: 3px;
    border: 1px solid rgba(0, 0, 0, 0.2);
`;
